import observeRegisterEvent from './register';
import observeSliderEvent from './slider';
import observeMatchEvent from './match';

const initBzTrackEvent = () => {
  observeRegisterEvent();
  observeSliderEvent();
  observeMatchEvent();
};

export default initBzTrackEvent;
